export default {
  confirm: "Confirm",
  cancel: "Prekliči",
  close: "Close",
  add: "Add",
  save: "Save",
  remove: "Remove",
  delete: "Izbriši",
  generate: "Generiraj",
  show_details: "Prikaži podrobnosti",
  open: "Odpri",
  edit: "Uredi",
  continue: "Nadaljuj",
  activate: "Aktiviraj",
  deactivate: "Deaktiviraj",
  components: {
    contact_info: {
      address: {
        title: "Address",
        remove_button: "Remove address",
        add_button: "Add address",
        address: "Address",
        postal: "Postal",
        city: "City",
        country: "Country"
      },
      contact: {
        title: "Kontakt",
        remove_button: "Odstrani kontakt",
        add_button: "Dodaj kontakt",
        contact: "Kontakt",
        phone: "Telefonska številka",
        email: "Elektronski naslov",
        any: "Kontakt",
        type: "Tip",
        label: "Ime in priimek"
      }
    },
    multiple_entries_check: {
      label: "Želite vpisati še eno?",
      description: "Po potrditvi bo forma ostala odprta"
    },
    cookies: {
      title: "Tudi mi pečemo piškotke",
      button: "Skrij obvestilo",
      text: "Spletna stran uporablja piškotke za zagotavljanje čim prijetnejše izkušnje. Uporablja samo piškotke, nujne za delovanje strani in ne za namene analitike ter marketinga. Z nadaljevanjem se strinjate z uporabo piškotkov."
    }
  },
  navigation: {
    profile: "Moj profil",
    experience: "Delovne izkušnje",
    documents: "Dokumenti",
    consents: "Soglasja",
    settings: "Nastavitve",
    logout: "Odjava"
  },
  static_data: {
    career_level: {
      "beginner": "Začetnik",
      "experienced-worker": "Izkušeni delavec",
      "experienced-expert": "Izkušeni strokovnjak",
      "middle-management": "Srednji management",
      "top-management": "Top management"
    },
    education: {
      "2": "II. - Osnovna šola",
      "3": "III. - Nižje poklicno izobraževanje (2 letno)",
      "4": "IV. - Srednje poklicno izobraževanje (3 letno)",
      "5": "V. - Gimnazijsko, srednje poklicno -tehniško izobraževanje, srednje tehniško oz. drugo strokovno izobraževanje",
      "6": "VI/1. - Višješolski program (do 1994), višješolski strokovni program",
      "7": "VI/2. - Specializacija po višješolskem programu, visokošolski strokovni programi, 1. bolonjska stopnja",
      "8": "VII. - Specializacija po visokošolskem strokovnem programu, univerzitetni program, 2. bolonjska stopnja",
      "9": "VIII/1. - Specializacija po univerzitetnem programu, magisterij znanosti",
      "10": "VIII/2. - Doktorat znanosti"
    }
  }
}
